module.exports = __webpack_public_path__ + "img/884b1494c29dce6b4aad2161a9b27055.809f985d.jpg";